import React from 'react'

function CustTextSize() {
  return (
    <>
    <h2>Custom text size in px</h2>
    <br/>
    <code>cust-txt-[value in integer(px)]</code>
    </>
  )
}

export default CustTextSize